import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (user?.force_password_change) {
    return <Navigate to="/change-password" replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user?.role)) {
    // Redirect to appropriate dashboard based on role
    if (user?.role === "super_admin") {
      return <Navigate to="/admin" replace />;
    } else if (user?.role === "kitchen") {
      return <Navigate to="/kitchen" replace />;
    } else if (user?.role === "cashier") {
      return <Navigate to="/cashier" replace />;
    } else if (user?.role === "waiter") {
      return <Navigate to="/waiter" replace />;
    } else {
      return <Navigate to="/manager" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
